import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Sun, Shield, TreePine, ShoppingBag, Utensils, Ticket, Mountain, Map, GraduationCap, BookOpen, Trophy } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
import { ListingsComingSoon } from '../components/ListingsComingSoon';
export function SummerlinPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="bg-white" data-id="element-942">
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[600px] w-full flex items-center justify-center overflow-hidden" data-id="element-943">
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2940&auto=format&fit=crop")'
      }} data-id="element-944">
          <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply" data-id="element-945"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80" data-id="element-946"></div>
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-947">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} data-id="element-948">
            <span className="text-gold uppercase tracking-[0.3em] text-sm font-medium mb-6 block" data-id="element-949">
              Community Spotlight
            </span>
            <h1 className="text-5xl md:text-7xl text-white font-serif mb-6 leading-tight" data-id="element-950">
              Summerlin
            </h1>
            <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto" data-id="element-951">
              Las Vegas's premier master-planned community, nestled against the
              stunning Red Rock Canyon.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Overview & Stats */}
      <section className="py-24 px-6 bg-white" data-id="element-952">
        <div className="max-w-7xl mx-auto" data-id="element-953">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-954">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-955">
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-956">
                The Pinnacle of{' '}
                <span className="italic text-gold" data-id="element-957">Desert Luxury</span>
              </h2>
              <div className="space-y-4 text-charcoal-light font-light leading-relaxed text-lg" data-id="element-958">
                <p data-id="element-959">
                  Developed by The Howard Hughes Corporation starting in 1990,
                  Summerlin spans 22,500 acres along the western rim of the Las
                  Vegas Valley. It is consistently ranked among the nation's
                  top-selling and most desirable master-planned communities.
                </p>
                <p data-id="element-960">
                  Home to over 100,000 residents across 30+ distinct villages,
                  Summerlin offers an unparalleled lifestyle that perfectly
                  balances natural beauty with urban sophistication. It is
                  widely recognized as one of the safest and most
                  well-maintained communities in Nevada.
                </p>
                <p data-id="element-961">
                  The real estate landscape is incredibly diverse, offering
                  everything from beautiful $400K starter homes and stylish
                  townhomes to breathtaking $10M+ custom estates perched on the
                  mountainside.
                </p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="grid grid-cols-2 gap-6" data-id="element-962">
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-963">
                <TreePine className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-964" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-965">250+</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-966">
                  Parks & Trails
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-967">
                <Sun className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-968" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-969">300</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-970">
                  Days of Sun
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-971">
                <Shield className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-972" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-973">Top</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-974">
                  Rated Schools
                </p>
              </div>
              <div className="bg-warmGray p-8 text-center border border-warmGray-dark" data-id="element-975">
                <MapPin className="w-8 h-8 text-gold mx-auto mb-4" data-id="element-976" />
                <h4 className="text-3xl font-serif text-charcoal mb-2" data-id="element-977">15m</h4>
                <p className="text-sm text-charcoal-light uppercase tracking-wider" data-id="element-978">
                  To The Strip
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Downtown Summerlin */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-979">
        <div className="max-w-7xl mx-auto" data-id="element-980">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-981">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-2 lg:order-1" data-id="element-982">
              <div className="relative h-[500px]" data-id="element-983">
                <img src="https://images.unsplash.com/photo-1519999482648-25049ddd37b1?q=80&w=2126&auto=format&fit=crop" alt="Downtown Summerlin Shopping" className="w-full h-full object-cover" data-id="element-984" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-985"></div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="order-1 lg:order-2" data-id="element-986">
              <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-987">
                The Heart of the Community
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-988">
                Downtown Summerlin
              </h2>
              <p className="text-charcoal-light font-light leading-relaxed text-lg mb-8" data-id="element-989">
                A vibrant 1.6 million square foot open-air shopping, dining, and
                entertainment district that serves as the urban core of the
                community.
              </p>

              <div className="space-y-6" data-id="element-990">
                <div className="flex items-start gap-4" data-id="element-991">
                  <ShoppingBag className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-992" />
                  <div data-id="element-993">
                    <h4 className="font-serif text-xl text-charcoal mb-1" data-id="element-994">
                      Premier Shopping
                    </h4>
                    <p className="text-charcoal-light font-light text-sm" data-id="element-995">
                      Over 125 stores including major retailers like Nordstrom,
                      Macy's, and Dillard's, alongside boutique shops.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-996">
                  <Utensils className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-997" />
                  <div data-id="element-998">
                    <h4 className="font-serif text-xl text-charcoal mb-1" data-id="element-999">
                      World-Class Dining
                    </h4>
                    <p className="text-charcoal-light font-light text-sm" data-id="element-1000">
                      A diverse culinary scene ranging from casual cafes and
                      weekly farmers markets to upscale fine dining experiences.
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-4" data-id="element-1001">
                  <Ticket className="w-6 h-6 text-gold flex-shrink-0 mt-1" data-id="element-1002" />
                  <div data-id="element-1003">
                    <h4 className="font-serif text-xl text-charcoal mb-1" data-id="element-1004">
                      Entertainment
                    </h4>
                    <p className="text-charcoal-light font-light text-sm" data-id="element-1005">
                      Features a luxury movie theater, fitness studios, and The
                      Pavilion — an outdoor event space hosting concerts and
                      holiday events.
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Sports & Entertainment */}
      <section className="py-24 px-6 bg-white" data-id="element-1006">
        <div className="max-w-7xl mx-auto" data-id="element-1007">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center mb-16" data-id="element-1008">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-1009">
              World-Class Venues
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-1010">
              Sports & Entertainment
            </h2>
            <p className="text-charcoal-light font-light max-w-2xl mx-auto mt-4" data-id="element-1011">
              Summerlin isn't just a residential area; it's a major hub for
              professional sports and luxury entertainment in Las Vegas.
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1012">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="group" data-id="element-1013">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-1014">
                <img src="https://images.unsplash.com/photo-1508344928928-7165b67de128?q=80&w=2940&auto=format&fit=crop" alt="Baseball Stadium" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1015" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-1016">
                Las Vegas Ballpark
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-1017">
                Home of the Las Vegas Aviators (Triple-A affiliate of the
                Oakland Athletics). This state-of-the-art 10,000-seat stadium
                offers an incredible game day experience right in Downtown
                Summerlin.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="group" data-id="element-1018">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-1019">
                <img src="https://images.unsplash.com/photo-1580748141549-71748dbe0bdc?q=80&w=2787&auto=format&fit=crop" alt="Ice Rink" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1020" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-1021">
                City National Arena
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-1022">
                The official practice facility for the Vegas Golden Knights NHL
                team. It features two ice sheets and is open to the community
                for public skating, youth leagues, and events.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="group" data-id="element-1023">
              <div className="relative h-64 mb-6 overflow-hidden" data-id="element-1024">
                <img src="https://images.unsplash.com/photo-1566073771259-6a8506099945?q=80&w=2940&auto=format&fit=crop" alt="Luxury Resort" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-1025" />
              </div>
              <h3 className="text-2xl font-serif text-charcoal mb-3" data-id="element-1026">
                Red Rock Resort
              </h3>
              <p className="text-charcoal-light font-light text-sm" data-id="element-1027">
                A stunning luxury resort and casino offering a world-class spa,
                bowling alley, movie theater, and multiple award-winning
                restaurants, serving as a playground for locals.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Outdoor Living */}
      <section className="py-24 bg-warmGray px-6 border-y border-warmGray-dark" data-id="element-1028">
        <div className="max-w-7xl mx-auto" data-id="element-1029">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1030">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="space-y-8" data-id="element-1031">
              <div data-id="element-1032">
                <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-1033">
                  Active Lifestyle
                </span>
                <h2 className="text-3xl md:text-4xl font-serif text-charcoal mb-6" data-id="element-1034">
                  Outdoor Recreation
                </h2>
                <p className="text-charcoal-light font-light leading-relaxed text-lg" data-id="element-1035">
                  Summerlin was designed for those who love the outdoors,
                  offering an unmatched array of recreational amenities set
                  against a stunning desert backdrop.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-1036">
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-1037">
                  <Mountain className="w-6 h-6 text-gold mb-3" data-id="element-1038" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-1039">
                    Red Rock Canyon
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-1040">
                    Just minutes away, offering world-class hiking, rock
                    climbing, and a 13-mile scenic drive.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-1041">
                  <Map className="w-6 h-6 text-gold mb-3" data-id="element-1042" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-1043">
                    Trail System
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-1044">
                    Over 150 miles of interconnected trails perfect for walking,
                    running, and cycling.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-1045">
                  <TreePine className="w-6 h-6 text-gold mb-3" data-id="element-1046" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-1047">
                    250+ Parks
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-1048">
                    Including major community hubs like Willows Park, The Vistas
                    Park, and Arbors Tennis Park.
                  </p>
                </div>
                <div className="bg-white p-6 border border-warmGray-dark" data-id="element-1049">
                  <Trophy className="w-6 h-6 text-gold mb-3" data-id="element-1050" />
                  <h4 className="font-serif text-lg text-charcoal mb-2" data-id="element-1051">
                    Championship Golf
                  </h4>
                  <p className="text-charcoal-light font-light text-sm" data-id="element-1052">
                    9 spectacular courses including TPC Las Vegas, Bear's Best,
                    and Angel Park Golf Club.
                  </p>
                </div>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-1053">
              <div className="relative h-[600px]" data-id="element-1054">
                <img src="https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2842&auto=format&fit=crop" alt="Red Rock Canyon Hiking" className="w-full h-full object-cover" data-id="element-1055" />
                <div className="absolute inset-0 border border-gold/30 m-4 pointer-events-none" data-id="element-1056"></div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Schools */}
      <section className="py-24 px-6 bg-white" data-id="element-1057">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1058">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-1059">
            <GraduationCap className="w-12 h-12 text-gold mx-auto mb-6" data-id="element-1060" />
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-1061">
              Education Focus
            </span>
            <h2 className="text-4xl font-serif text-charcoal mb-6" data-id="element-1062">
              Exceptional Schools
            </h2>
            <p className="text-charcoal-light font-light leading-relaxed text-lg mb-12" data-id="element-1063">
              Education is a cornerstone of the Summerlin community. It is home
              to some of the highest-rated public schools in the Clark County
              School District, including Sig Rogich Middle School and Palo Verde
              High School. Additionally, Summerlin offers prestigious private
              school options like The Meadows School, ensuring excellent
              educational opportunities for families.
            </p>
            <div className="flex justify-center gap-8" data-id="element-1064">
              <div className="flex items-center gap-2 text-charcoal" data-id="element-1065">
                <BookOpen className="w-5 h-5 text-gold" data-id="element-1066" />
                <span className="font-serif" data-id="element-1067">Top Public Schools</span>
              </div>
              <div className="flex items-center gap-2 text-charcoal" data-id="element-1068">
                <BookOpen className="w-5 h-5 text-gold" data-id="element-1069" />
                <span className="font-serif" data-id="element-1070">Elite Private Academies</span>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Neighborhood Highlights */}
      <section className="py-24 bg-warmGray px-6 border-t border-warmGray-dark" data-id="element-1071">
        <div className="max-w-7xl mx-auto" data-id="element-1072">
          <div className="text-center mb-16" data-id="element-1073">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-1074">
              Exclusive Enclaves
            </span>
            <h2 className="text-4xl font-serif text-charcoal" data-id="element-1075">
              Summerlin Villages
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1076">
            {[{
            name: 'The Ridges',
            price: '$1M - $10M+',
            desc: 'Ultra-luxury custom homes built into the mountainside with a private Jack Nicklaus golf course and stunning Strip views.',
            img: 'https://images.unsplash.com/photo-1613490908571-9ce224083933?q=80&w=2838&auto=format&fit=crop'
          }, {
            name: 'The Summit Club',
            price: '$3M - $30M+',
            desc: 'The most exclusive private golf and lifestyle community in Las Vegas, offering unmatched luxury and a Tom Fazio course.',
            img: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2950&auto=format&fit=crop'
          }, {
            name: 'Red Rock Country Club',
            price: '$500K - $2M+',
            desc: 'Guard-gated community featuring two Arnold Palmer golf courses, a luxurious clubhouse, and stunning canyon views.',
            img: 'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2906&auto=format&fit=crop'
          }, {
            name: 'The Paseos',
            price: '$400K - $700K',
            desc: 'A highly sought-after, family-friendly village featuring excellent parks, top schools, and beautiful elevated views.',
            img: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2940&auto=format&fit=crop'
          }, {
            name: 'Reverence',
            price: '$500K - $1.2M',
            desc: 'A newer luxury development by Pulte Homes offering modern architecture, a private clubhouse, and mountain views.',
            img: 'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?q=80&w=2940&auto=format&fit=crop'
          }, {
            name: 'Stonebridge',
            price: '$450K - $800K',
            desc: 'An established neighborhood known for its mature landscaping, strong community feel, and proximity to Red Rock.',
            img: 'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?q=80&w=2792&auto=format&fit=crop'
          }].map((village, idx) => <motion.div key={village.name} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-white p-6 shadow-sm border border-warmGray-dark" data-id="element-1077">
                <img src={village.img} alt={village.name} className="w-full h-48 object-cover mb-4" data-id="element-1078" />
                <div className="flex justify-between items-start mb-3" data-id="element-1079">
                  <h3 className="text-xl font-serif text-charcoal" data-id="element-1080">
                    {village.name}
                  </h3>
                  <span className="text-xs font-medium text-gold bg-gold/10 px-2 py-1 rounded" data-id="element-1081">
                    {village.price}
                  </span>
                </div>
                <p className="text-charcoal-light font-light text-sm leading-relaxed" data-id="element-1082">
                  {village.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      <ListingsComingSoon area="Summerlin" data-id="element-1083" />

      <ContactCTA data-id="element-1084" />
    </main>;
}